import React, { PureComponent } from "react";

import { Popover, OverlayTrigger } from "react-bootstrap";
import { Button, ButtonGroup, Dropdown } from "aible";

import { isEnabled } from "utils/featureFlags";

import Select from "react-select";

import numeral from "numeral";
import moment from "moment";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { LineInput } from "components/Inputs/LineInput";
import ProfitSlider from "components/Project/ProfitSlider";
import AdvancedDeploy from "components/Project/AdvancedDeploy";
import LineChart from "components/Project/LineChart";

import { TIME_PERIOD_OPTIONS, TIME_PERIOD_TRANSLATION } from "containers/Setup/reducer";

import FrontierSlidersContainer from "containers/FrontierSliders/FrontierSliders";
import { FRONTIER_SLIDERS_VIEW } from "containers/FrontierSliders/FrontierSliders";

import styles from "./style.module.css";

function formatValue(value) {
  if (isNaN(value)) {
    return value;
  }
  if (value < 1) {
    return parseFloat(value).toPrecision(3);
  }
  return numeral(value).format("0.[00]");
}

export default class CompareScenario extends PureComponent {
  constructor(props) {
    super(props);
    const { skipToAdvancedOptions, isAdvancedOptions } = props;
    this.state = {
      deployMode: skipToAdvancedOptions || isAdvancedOptions ? "advanced" : "selected"
    };
  }

  componentWillUnmount() {
    const { skipToAdvancedOptions, updateSkipToAdvancedOptions } = this.props;
    if (skipToAdvancedOptions) {
      updateSkipToAdvancedOptions(false);
    }
  }

  renderSelected() {
    const { allScenarios, selectedScenario, deployedScenarioIndex, timePeriod } = this.props;

    const retDisplayTimePeriod = TIME_PERIOD_TRANSLATION[timePeriod] || "";

    return (
      <div>
        <div className={styles.depHeader}>
          <div>
            <div className={styles.deployHeader}>{"Review Scenario Impact"}</div>
            <div className={styles.deploySubHeader}>
              {"The potential impact if the most extreme " + "shortlisted scenarios prove to be more accurate."}
            </div>
          </div>
          {selectedScenario && selectedScenario.scenarioStats && selectedScenario.scenarioStats.profit ? (
            <div>
              <div className={styles.deployHeader}>{numeral(selectedScenario.scenarioStats.profit).format("0.0a")}</div>
              <div className={styles.deploySubHeader}>
                {"Expected" + (retDisplayTimePeriod ? retDisplayTimePeriod + " " : "") + " Impact"}
              </div>
            </div>
          ) : (
            <React.Fragment />
          )}
        </div>
        <div className={styles.lineGraph}>
          <LineChart
            scenarios={allScenarios}
            selectedScenario={selectedScenario}
            deployedIndex={deployedScenarioIndex}
            timePeriod={timePeriod}
          />
        </div>
        <div className={styles.depTable}>
          <div className={styles.depTableHeader}>
            <div className={styles.depLarge}>{"Scenario & Subgroups"}</div>
            <div className={styles.depSmall}>{"Profit"}</div>
            <div className={styles.depSmall}>{"Revenue"}</div>
            <div className={styles.depSmall}>{"Resourcing"}</div>
            <div className={styles.depSmall}>{"Processing Capacity"}</div>
            <div className={styles.depSmall}>{"Creator"}</div>
            <div className={styles.depSmall}>{"Date Created"}</div>
          </div>
          <div className={styles.depTableBody}>
            {selectedScenario &&
              selectedScenario.scenario &&
              Object.keys(selectedScenario.scenario).map((s, i) => (
                <div className={styles.depTableRow} key={i}>
                  <div className={styles.depLarge}>{s}</div>
                  <div className={styles.depSmall}>{formatValue(selectedScenario.scenario[s].profit)}</div>
                  <div className={styles.depSmall}>{formatValue(selectedScenario.scenario[s].revenue)}</div>
                  <div className={styles.depSmall}>{formatValue(selectedScenario.scenario[s].cost)}</div>
                  <div className={styles.depSmall}>
                    {s !== "Overall" && selectedScenario.scenario[s].capValue
                      ? selectedScenario.scenario[s].capValue.toFixed(2) + "%"
                      : ""}
                  </div>
                  <div className={styles.depSmall}>
                    {selectedScenario.originalScenario.created_by
                      ? selectedScenario.originalScenario.created_by.fullname
                      : ""}
                  </div>
                  <div
                    className={styles.depSmall}
                    title={moment
                      .utc(selectedScenario.originalScenario.created_date)
                      .local()
                      .format("MMMM Do YYYY, h:mm:ss a")}
                  >
                    {moment.utc(selectedScenario.originalScenario.created_date).local().fromNow()}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    );
  }

  renderShortlisted() {
    const { selectedScenario, allScenarios, timePeriod } = this.props;

    return (
      <div>
        <div className={styles.depHeader}>
          <div>
            <div className={styles.deployHeader}>{"Review Scenario Impact"}</div>
            <div className={styles.deploySubHeader}>
              {"The potential impact if the most extreme " + "shortlisted scenarios prove to be more accurate."}
            </div>
          </div>
          {selectedScenario && selectedScenario.scenarioStats && (
            <div>
              <div className={styles.deployHeader}>{numeral(selectedScenario.scenarioStats.profit).format("0.0a")}</div>
              <div className={styles.deploySubHeader}>{"Expected Monthly Impact"}</div>
            </div>
          )}
        </div>
        <div className={styles.lineGraph}>
          <LineChart
            scenarios={allScenarios}
            selectedScenario={selectedScenario}
            hoverScenario={this.state.hScenario}
            timePeriod={timePeriod}
          />
        </div>
        <div className={styles.depTable}>
          <div className={styles.depTableHeader}>
            <div className={styles.depLarge}>{"Shortlisted Scenarios"}</div>
            <div className={styles.depSmall}>{"Expected Profit"}</div>
            <div className={styles.depSmall}>{"Revenue"}</div>
            <div className={styles.depSmall}>{"Creator"}</div>
            <div className={styles.depSmall}>{"Date Created"}</div>
          </div>
          <div className={styles.depTableBody} onMouseLeave={() => this.setState({ hScenario: undefined })}>
            {allScenarios &&
              allScenarios.map((s, i) => (
                <div
                  className={styles.depTableRow + " " + styles.depHover}
                  key={i}
                  onMouseEnter={() => this.setState({ hScenario: s.originalScenario.id })}
                >
                  <div className={styles.depLarge}>{s.originalScenario.name}</div>
                  <div className={styles.depSmall}>{s.profit}</div>
                  <div className={styles.depSmall}>{s.revenue}</div>
                  <div className={styles.depSmall}>
                    {s.originalScenario.created_by ? s.originalScenario.created_by.fullname : ""}
                  </div>
                  <div
                    className={styles.depSmall}
                    title={moment.utc(s.originalScenario.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
                  >
                    {moment.utc(s.originalScenario.created_date).local().fromNow()}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    );
  }

  renderDeploy() {
    const { selectedScenario, project, optimized, allScenarios, isFullScreen, isAdvancedOptions, isNext } = this.props;
    const { deployHoverIndex, isAdvancedDeploy, deployMode } = this.state;

    const totalWorked =
      selectedScenario && selectedScenario.scenario
        ? Object.keys(selectedScenario.scenario)
            .filter((k) => k !== "Overall")
            .reduce((a, b) => a + selectedScenario.scenario[b].totalWorked, 0)
        : undefined;

    const total =
      selectedScenario && selectedScenario.scenario
        ? Object.keys(selectedScenario.scenario)
            .filter((k) => k !== "Overall")
            .reduce((a, b) => a + selectedScenario.scenario[b].total, 0)
        : undefined;
    const totalWorkedPct =
      total !== undefined && totalWorked !== undefined ? ((totalWorked / total) * 100).toFixed(2) + "%" : undefined;

    const sortedScenarios = allScenarios.sort((a, b) => b.profit - a.profit);

    const bestScenario = sortedScenarios.length > 1 ? sortedScenarios[0] : undefined;
    const worstScenario = sortedScenarios.length > 1 ? sortedScenarios[sortedScenarios.length - 1] : undefined;

    const hoverScenario = deployHoverIndex !== undefined ? sortedScenarios[deployHoverIndex] : undefined;

    return (
      <div
        className={styles.nDeploy}
        style={{
          height: isNext
            ? "calc(100vh - 260px)"
            : isAdvancedOptions
              ? "calc(100vh - 360px)"
              : isFullScreen
                ? "100%"
                : undefined
        }}
      >
        {!isNext && (
          <div className={styles.deployTabs}>
            <div className={styles.deployHeader} style={{ marginRight: "20px" }}>
              {"Deployment Review"}
            </div>
            <ButtonGroup>
              <Button active={deployMode === "selected"} onClick={() => this.setState({ deployMode: "selected" })}>
                {"Selected Scenario"}
              </Button>
              <Button active={deployMode === "advanced"} onClick={() => this.setState({ deployMode: "advanced" })}>
                {"Advanced Options"}
              </Button>
            </ButtonGroup>
          </div>
        )}
        {deployMode === "advanced" ? (
          <AdvancedDeploy {...this.props} />
        ) : deployMode === "selected" ? (
          this.renderSelected()
        ) : (
          <React.Fragment />
        )}
      </div>
    );
  }

  renderDeployContinuous() {
    const { selectedScenario, project, optimized, allScenarios } = this.props;
    const { deployHoverIndex, isAdvancedDeploy } = this.state;

    const totalWorked =
      selectedScenario && selectedScenario.scenario
        ? Object.keys(selectedScenario.scenario)
            .filter((k) => k !== "Overall")
            .reduce((a, b) => a + selectedScenario.scenario[b].totalWorked, 0)
        : undefined;

    const total =
      selectedScenario && selectedScenario.scenario
        ? Object.keys(selectedScenario.scenario)
            .filter((k) => k !== "Overall")
            .reduce((a, b) => a + selectedScenario.scenario[b].total, 0)
        : undefined;
    const totalWorkedPct =
      total !== undefined && totalWorked !== undefined ? ((totalWorked / total) * 100).toFixed(2) + "%" : undefined;

    const sortedScenarios = allScenarios
      .map((e) => e)
      .sort((a, b) => a.overPredict + a.underPredict - (b.overPredict + b.underPredict));

    const bestScenario = sortedScenarios.length > 1 ? sortedScenarios[0] : undefined;
    const worstScenario = sortedScenarios.length > 1 ? sortedScenarios[sortedScenarios.length - 1] : undefined;

    const hoverScenario = deployHoverIndex !== undefined ? sortedScenarios[deployHoverIndex] : undefined;

    return (
      <div className={styles.deploy}>
        <div className={styles.deployHeader}>{"Review Your Selected Efficient Frontier"}</div>
        <div className={styles.deploySubHeader}>
          {"Here are the expected over prediction and under prediction costs for your selected scenario."}
        </div>
        {selectedScenario && selectedScenario.scenarioStats && selectedScenario.originalScenario && (
          <div className={styles.deployHolder}>
            <div className={styles.deployFrontier}>
              <div className={styles.scenarioStats} style={{ marginRight: "20px" }}>
                <div className={styles.dSub}>{"Selected Scenario Costs"}</div>
                <div className={styles.sBox}>
                  <div className={styles.statItem} style={{ fontSize: "20px", fontWeight: "bold" }}>
                    <div>{"Error Cost"}</div>
                    <div>
                      {numeral(
                        selectedScenario.scenarioStats.overEstimate + selectedScenario.scenarioStats.underEstimate
                      ).format("0.0a")}
                    </div>
                  </div>
                  <div className={styles.statItem}>
                    <div>{"Over Prediction Cost"}</div>
                    <div>{numeral(selectedScenario.scenarioStats.overEstimate).format("0.0a")}</div>
                  </div>
                  <div className={styles.statItem}>
                    <div>{"Under Prediction Cost"}</div>
                    <div>{numeral(selectedScenario.scenarioStats.underEstimate).format("0.0a")}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.selFooter}>
              <div className={styles.fItem}>
                <div className={styles.fTop}>{"Scenario Id"}</div>
                <div className={styles.fBot}>{selectedScenario.originalScenario.id}</div>
              </div>
              <div className={styles.fItem}>
                <div className={styles.fTop}>{"Modified Segments"}</div>
                <div className={styles.fBot}>
                  {selectedScenario.originalScenario.elements ? selectedScenario.originalScenario.elements.length : -1}
                </div>
              </div>
              <div className={styles.fItem}>
                <div className={styles.fTop}>{"Created By"}</div>
                <div className={styles.fBot}>
                  {selectedScenario.originalScenario.created_by
                    ? selectedScenario.originalScenario.created_by.fullname
                    : ""}
                </div>
              </div>
              <div className={styles.fItem}>
                <div className={styles.fTop}>{"Created On"}</div>
                <div className={styles.fBot}>
                  {selectedScenario.originalScenario.created_date
                    ? moment
                        .utc(selectedScenario.originalScenario.created_date)
                        .local()
                        .format("MMMM Do YYYY, h:mm:ss a")
                    : ""}
                </div>
              </div>
              <div className={styles.fItem}>
                <div className={styles.fTop}>{"Last Updated"}</div>
                <div className={styles.fBot}>
                  {selectedScenario.originalScenario.updated_date
                    ? moment
                        .utc(selectedScenario.originalScenario.updated_date)
                        .local()
                        .format("MMMM Do YYYY, h:mm:ss a")
                    : ""}
                </div>
              </div>
            </div>
          </div>
        )}
        {worstScenario ? (
          <div>
            <div className={styles.deployHeader}>{"Worst Case / Best Case if you deploy the Current Selection"}</div>
            <div className={styles.deploySubHeader}>
              {"Here are the expected outcomes if the assumptions from a different scenario prove to be more accurate. " +
                "If the risk is more than you prefer, Aible recommends deploying a different scenario. "}
            </div>
            <div className={styles.bestWorst}>
              <div className={styles.scenarioStats}>
                {"Worst Case"}
                <div className={styles.sBox} style={{ background: "#D82149" }}>
                  <div className={styles.statItem} style={{ fontSize: "20px", fontWeight: "bold" }}>
                    <div>{"Error Cost"}</div>
                    <div>{numeral(worstScenario.overPredict + worstScenario.underPredict).format("0.0a")}</div>
                  </div>
                  <div className={styles.statItem}>
                    <div>{"Over Prediction Cost"}</div>
                    <div>{numeral(worstScenario.overPredict).format("0.0a")}</div>
                  </div>
                  <div className={styles.statItem}>
                    <div>{"Under Prediction Cost"}</div>
                    <div>{numeral(worstScenario.underPredict).format("0.0a")}</div>
                  </div>
                </div>
              </div>
              {hoverScenario !== undefined && (
                <div className={styles.scenarioStats}>
                  {"Viewing Scenario"}
                  <div className={styles.sBox} style={{ background: "#F47C20" }}>
                    <div className={styles.statItem} style={{ fontSize: "20px", fontWeight: "bold" }}>
                      <div>{"Error Cost"}</div>
                      <div>{numeral(hoverScenario.overPredict + hoverScenario.underPredict).format("0.0a")}</div>
                    </div>
                    <div className={styles.statItem}>
                      <div>{"Over Prediction Cost"}</div>
                      <div>{numeral(hoverScenario.overPredict).format("0.0a")}</div>
                    </div>
                    <div className={styles.statItem}>
                      <div>{"Under Prediction Cost"}</div>
                      <div>{numeral(hoverScenario.underPredict).format("0.0a")}</div>
                    </div>
                  </div>
                </div>
              )}
              <div className={styles.scenarioStats}>
                {"Best Case"}
                <div className={styles.sBox} style={{ background: "#5BCF74" }}>
                  <div className={styles.statItem} style={{ fontSize: "20px", fontWeight: "bold" }}>
                    <div>{"Error Cost"}</div>
                    <div>{numeral(bestScenario.overPredict + bestScenario.underPredict).format("0.0a")}</div>
                  </div>
                  <div className={styles.statItem}>
                    <div>{"Over Prediction Cost"}</div>
                    <div>{numeral(bestScenario.overPredict).format("0.0a")}</div>
                  </div>
                  <div className={styles.statItem}>
                    <div>{"Under Prediction Cost"}</div>
                    <div>{numeral(bestScenario.underPredict).format("0.0a")}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div />
        )}
        {sortedScenarios && worstScenario && (
          <div className={styles.deploySlider}>
            <ProfitSlider
              data={sortedScenarios.map((s, i) => ({
                value: -1 * (s.scenarioStats ? s.scenarioStats.underEstimate + s.scenarioStats.overEstimate : 0),
                label: s.id,
                index: i
              }))}
              current={{
                value:
                  -1 *
                  (selectedScenario.scenarioStats
                    ? selectedScenario.scenarioStats.underEstimate + selectedScenario.scenarioStats.overEstimate
                    : 0)
              }}
              onHover={(index) => this.setState({ deployHoverIndex: index })}
            />
          </div>
        )}
        <div className={styles.aDeployWrapper}>
          <Button
            style={{ margin: "20px 0px 0px" }}
            active={isAdvancedDeploy}
            onClick={() => this.setState({ isAdvancedDeploy: !isAdvancedDeploy })}
          >
            {isAdvancedDeploy ? "Hide Advanced Options" : "Show Advanced Options"}
          </Button>
          {isAdvancedDeploy ? <AdvancedDeploy {...this.props} /> : ""}
        </div>
      </div>
    );
  }

  render() {
    const { optimized } = this.props;

    const isContinuous =
      optimized &&
      optimized.bestModel &&
      optimized.bestModel.metrics &&
      optimized.bestModel.metrics.overImpact !== undefined &&
      optimized.bestModel.metrics.underImpact !== undefined;

    return isContinuous ? this.renderDeployContinuous() : this.renderDeploy();
  }
}
